import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGamerList = (params) => {
    return axios.get(`${backendHost}/api/admin/gamer/list`, {params});
};

export {
    getGamerList
}